import React, { useEffect, useState } from "react";
import { TextField, Button, MenuItem, Card, Typography, Switch } from "@mui/material";
import { categoryApi } from "store/api";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import CategoryClip from "./CategoryClip";
import Rating from "@mui/material/Rating";
import { addProductApi } from "store/api";
import Success from "components/Success";
import { useNavigate } from "react-router-dom";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { subCategoryApi } from "store/api";
import BrandClip from "./BrandClip";
import { getAllBrandApi } from "store/api";

const ProductForm = () => {
  const navigate = useNavigate();
  const [msg, setMsg] = useState("");
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const [brands, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState([]);
  const [basicDetail, setBasicDetail] = useState({
    name: "",
    slug: "",
    description: "",
    price: 0,
    discountPrice: 0,
    rating: "",
    brandId: "",
    trending: false,
    isActive: false,
    subCategoryIds: [],
    productAttributes: [],
  });
  const [productDescription, setProductDescription] = useState([{ id: 1, description: "" }]);
  const [productCharacteristic, setProductCharacteristic] = useState([
    { id: 1, key: "", value: "", order: 1 },
  ]);
  const getAllCategory = async () => {
    const response = await categoryApi();
    if (response?.success) {
      setCategories(response?.data);
    }
  };
  const getAllBrand = async () => {
    const response = await getAllBrandApi();
    if (response?.success) {
      setBrands(response?.data);
    }
  };

  const handleChangeBasicDetail = e => {
    const { name, value } = e.target;
    setBasicDetail({ ...basicDetail, [name]: name == "rating" ? String(value) : value });
  };

  // Handle input change
  const handleChangeCharacteristic = (index, event) => {
    const { name, value } = event.target;
    const newProductCharacteristic = [...productCharacteristic];
    newProductCharacteristic[index][name] = value;
    setProductCharacteristic(newProductCharacteristic);
  };

  // Add new Characteristic
  const addCharacteristic = () => {
    setProductCharacteristic([
      ...productCharacteristic,
      { id: Date.now(), keyEn: "", keyUz: "", valueEn: "", valueUz: "" },
    ]);
  };

  // Remove a Characteristic
  const removeCharacteristic = id => {
    if (id != 1)
      setProductCharacteristic(
        productCharacteristic.filter(characteristic => characteristic.id !== id)
      );
  };

  // Handle input change
  const handleChangeDescription = event => {
    const { value } = event.target;
    setBasicDetail(prev => ({
      ...prev,
      description: value,
    }));
  };

  const [checkedTrending, setCheckedTrending] = useState(false);
  const [checkedIsActive, setCheckedIsActive] = useState(false);

  const handleChangeTrending = event => {
    setCheckedTrending(event.target.checked);
  };
  const handleChangeIsActive = event => {
    setCheckedIsActive(event.target.checked);
  };

  const [error, setError] = useState();
  const [errorMsg, setErrorMsg] = useState();
  const handleSubmit = async e => {
    e.preventDefault();
    if (!basicDetail?.rating) {
      setErrorMsg("Please select rating");
      setError(true);
    } else if (!selectedBrand?.length) {
      setErrorMsg("Please select Brand");
      setError(true);
    } else if (!selectedSubCategories?.length) {
      setErrorMsg("Please select minimum one category");
      setError(true);
    } else {
      const data = {
        ...basicDetail,
        productAttributes: productCharacteristic,
        subCategoryIds: selectedSubCategories.map(sub => sub.subCategoryId),
        brandId: selectedBrand[0]?.brandId,
        isActive: checkedIsActive,
        trending: checkedTrending,
      };
      const response = await addProductApi(data);
      if (response?.success) {
        setMsg("Product Add Successfully");
        setSuccess(true);
        setTimeout(() => {
          navigate("/product-details", {
            state: { productId: response?.data?.productDetails?.productId },
          });
        }, [2000]);
      } else {
        setSuccess(false);
        setMsg("Something went wrong. Please try again later.");
      }
      if (response?.response) {
        setSuccess(false);
        setMsg(response?.response?.data?.message);
      }
      setOpen(true);
    }
  };

  const [selectedSubCategories, setSelectedSubCategories] = useState([]);

  // Simulate API call
  const fetchSubCategories = async categoryId => {
    const response = await subCategoryApi({ categoryId: categoryId });
    if (response?.success) {
      // setSelectedSubCategories(response?.data);
      return response?.data;
    }
  };

  useEffect(() => {
    getAllBrand();
    getAllCategory();
  }, []);

  return (
    <form onSubmit={handleSubmit}>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", paddingBottom: "10px" }}>
        <Card style={{ flex: 1, padding: "20px", minWidth: "100%" }}>
          <Typography variant='h6'>Product Basic Details</Typography>
          <div style={{ display: "flex", gap: "16px" }}>
            <TextField
              required
              type='text'
              fullWidth
              label='Product Name'
              name='name'
              variant='outlined'
              margin='normal'
              value={basicDetail?.name}
              onChange={handleChangeBasicDetail}
            />
          </div>
          <div style={{ display: "flex", gap: "16px" }}>
            <TextField
              required
              type='text'
              fullWidth
              label='Product Slug'
              name='slug'
              variant='outlined'
              margin='normal'
              value={basicDetail?.slug}
              style={{ width: "100%" }}
              onChange={handleChangeBasicDetail}
            />
            <TextField
              // required
              type='number'
              select
              inputProps={{ min: 1 }}
              fullWidth
              label='Product Rating'
              name='rating'
              variant='outlined'
              margin='normal'
              style={{ width: "30%" }}
              value={basicDetail.rating}
              onChange={handleChangeBasicDetail}
              className='rating-box'
            >
              <MenuItem value={1}>1</MenuItem>
              <MenuItem value={2}>2</MenuItem>
              <MenuItem value={3}>3</MenuItem>
              <MenuItem value={4}>4</MenuItem>
              <MenuItem value={5}>5</MenuItem>
            </TextField>
          </div>
          <div style={{ display: "flex", gap: "16px" }}>
            <TextField
              required
              type='number'
              inputProps={{ min: 1 }}
              fullWidth
              label='Price'
              name='price'
              variant='outlined'
              margin='normal'
              style={{ width: "50%" }}
              value={basicDetail?.price}
              onChange={handleChangeBasicDetail}
            />
            <TextField
              required
              type='number'
              fullWidth
              inputProps={{ min: 1 }}
              label='Discount Price'
              name='discountPrice'
              variant='outlined'
              margin='normal'
              style={{ width: "47.5%" }}
              value={basicDetail?.discountPrice}
              onChange={handleChangeBasicDetail}
            />
            {/* <CategoryClip
              categories={categories}
              selectedCategories={selectedCategory}
              setSelectedCategories={setSelectedCategory}
            /> */}
            <BrandClip
              categories={brands}
              setSelectedCategories={setSelectedBrand}
              selectedCategories={selectedBrand}
            />
            <CategoryClip
              categories={categories}
              setSelectedCategories={setSelectedCategory}
              fetchSubCategories={fetchSubCategories}
              selectedCategories={selectedCategory}
              selectedSubCategories={selectedSubCategories}
              setSelectedSubCategories={setSelectedSubCategories}
            />
          </div>
        </Card>

        <Card style={{ flex: 1, padding: "20px", minWidth: "50%" }}>
          <Typography
            variant='h6'
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
          >
            Product Description
          </Typography>
          {/* {productDescription.map((description, index) => ( */}
          <div style={{ display: "flex", gap: "10px", marginBottom: "0px", alignItems: "center" }}>
            <TextField
              required
              type='text'
              fullWidth
              label='Description'
              name='description'
              variant='outlined'
              margin='normal'
              multiline
              maxRows={4}
              value={basicDetail.description}
              onChange={e => handleChangeDescription(e)}
            />
          </div>
          {/* ))} */}
        </Card>
        <Card style={{ flex: 1, padding: "20px", minWidth: "300px" }}>
          <Typography
            variant='h6'
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
          >
            Product Attributes
            {
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "10px",
                  gap: "2px",
                  border: "1px solid",
                  borderRadius: "4px",
                  padding: "4px 12px 4px 8px",
                  cursor: "pointer",
                }}
                onClick={addCharacteristic}
              >
                <AddRoundedIcon style={{ fontSize: "36px" }} /> Add
              </span>
            }
          </Typography>
          {productCharacteristic.map((characteristic, index) => (
            <div
              key={characteristic.id}
              style={{ display: "flex", gap: "10px", marginBottom: "0px", alignItems: "center" }}
            >
              <TextField
                required
                type='text'
                fullWidth
                label='Attribute Key'
                name='key'
                variant='outlined'
                margin='normal'
                multiline
                maxRows={4}
                value={characteristic.key}
                style={{ width: "50%" }}
                onChange={e => handleChangeCharacteristic(index, e)}
              />
              <TextField
                required
                type='text'
                fullWidth
                label='Attribute Value'
                name='value'
                variant='outlined'
                margin='normal'
                multiline
                maxRows={4}
                style={{ width: "30%" }}
                value={characteristic.value}
                onChange={e => handleChangeCharacteristic(index, e)}
              />
              <TextField
                required
                type='number'
                fullWidth
                label='Order'
                name='order'
                variant='outlined'
                margin='normal'
                multiline
                maxRows={4}
                style={{ width: "20%" }}
                value={characteristic.order}
                onChange={e => handleChangeCharacteristic(index, e)}
              />
              {characteristic.id != 1 && (
                <CloseRoundedIcon onClick={() => removeCharacteristic(characteristic.id)} />
              )}
            </div>
          ))}
        </Card>
        <Card style={{ flex: 1, padding: "20px", minWidth: "300px" }}>
          <Typography
            variant='h6'
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
          >
            Product Trending
          </Typography>
          <Switch
            name='isTrending'
            checked={checkedTrending}
            onChange={handleChangeTrending}
            inputProps={{ "aria-label": "controlled" }}
          />
        </Card>
        <Card style={{ flex: 1, padding: "20px", minWidth: "300px" }}>
          <Typography
            variant='h6'
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
          >
            Product Active
          </Typography>
          <Switch
            name='isActive'
            checked={checkedIsActive}
            onChange={handleChangeIsActive}
            inputProps={{ "aria-label": "controlled" }}
          />
        </Card>
        {error && (
          <div
            style={{
              color: "red",
              fontSize: "16px",
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <InfoOutlinedIcon /> {errorMsg}
          </div>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            paddingTop: "20px",
            width: "100%",
          }}
        >
          <Button color='warning' variant='contained'>
            Cancel
          </Button>
          <Button variant='contained' color='success' type='submit'>
            Submit
          </Button>
        </div>
      </div>
      <Success open={open} success={success} msg={msg} handleClose={handleClose} />
    </form>
  );
};

export default ProductForm;
